import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthProvider';
import { WebsocketProvider } from './context/WebsocketProvider';
import { NotificationsProvider } from './context/NotificationsProvider';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  //   <Router>
  //     <App />
  //   </Router>
  // </React.StrictMode>
    <Router>
      <AuthProvider>
        <NotificationsProvider>
          <WebsocketProvider>
            <Routes>
              <Route
                path='/*'
                element={<App />}/>
            </Routes>
          </WebsocketProvider>
        </NotificationsProvider>
      </AuthProvider>
    </Router>
);

